module.exports = {"data":{"settings":{"edges":[{"node":{"id":"c2yj3ZI1rUomyw4uyG0WCeE","name":"Spread the Bubble's","style":{"_json_":"{}"},"options":{"_json_":"{}"},"node_locale":"fr-BE"}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 346
// module chunks = 60335399758886 114276838955818